export default __webpack_public_path__ + "static/media/theme_påske.8ea8b3e3.jpg";